/**
 * AdminHeroLeadsPage — /admin/hero-leads
 *
 * Full-page wrapper for the HeroLeadsPanel. Requires admin role;
 * non-admins get bounced to /dashboard.
 */
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { Button } from '../components/ui/button';
import { ArrowLeft, Users } from 'lucide-react';
import { useAuth } from '../lib/auth-context';
import HeroLeadsPanel from '../components/admin/HeroLeadsPanel';

export default function AdminHeroLeadsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin' && !(Array.isArray(user.admin_features) && user.admin_features.includes('hero_leads'))) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AppShell>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin')}
          className="-ml-2 gap-1.5"
          data-testid="hero-leads-back"
        >
          <ArrowLeft size={14} /> Back to admin
        </Button>
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300 px-3 py-1 text-[11px] font-mono-edge tracking-[0.16em] uppercase">
            <Users size={12} /> Hero Leads
          </div>
          <h1 className="mt-3 text-3xl font-bold text-foreground">Home hero captures</h1>
          <p className="text-muted-foreground mt-1">
            Every LinkedIn URL + goal + plan choice submitted from the home hero, whether the visitor completed checkout or not.
          </p>
        </div>
        <HeroLeadsPanel />
      </div>
    </AppShell>
  );
}
